export default {
  "fontElementMap": "fdVed",
  "linkPreviewContainer": "uM8-R",
  "linkPreview": "H6Ooj",
  "linkPreviewImage": "lzZ6x",
  "linkPreviewInfo": "_-8VCb",
  "linkPreviewTitle": "gdopy",
  "linkPreviewDescription": "CRH5Q",
  "linkPreviewUrl": "_30X0v"
};